// Terminal state — the bridge / hardware is unreachable. Full-bleed, dark,
// no actions; an operator restart is what clears it.

import { BrandMark } from "../components/BrandMark";
import { WrenchMark } from "../components/Illustrations";
import { useLang } from "../i18n/LangContext";
import type { KioskState } from "../state/types";

type OutOfService = Extract<KioskState, { phase: "out-of-service" }>;

export function OutOfServiceScreen({ state }: { state: OutOfService }) {
  const { t } = useLang();
  return (
    <div className="oos">
      <BrandMark onDark size="lg" />
      <div className="status-badge status-badge--neutral">
        <WrenchMark />
      </div>
      <h1 className="oos__title">{t("oosTitle")}</h1>
      {state.reason ? <p className="oos__detail">{state.reason}</p> : null}
      <p className="oos__detail">{t("oosHint")}</p>
    </div>
  );
}
